import axios from 'axios';
import Common from '../componets/Common';

export const validarVisa = async (invoice, authPayment) => {
  const url = `${Common.urlAPI}/ValidarVisa/${invoice}`;

  try {
    const resValidadoVisa = await axios.get(url, authPayment);
    if (resValidadoVisa.data.state !== 'OK') {
      alert('No se pudo validar por Visa, vuelva a intentarlo nuevamente');
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      alert('El token es invalido para este usuario');
    }
  }
  // return resValidadoVisa;
};
